// Import model
import { DataviewProjectTaskResponse } from '../models/DataviewProjectTaskResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { FilterProjectTaskRequest } from '../models/FilterProjectTaskRequest';
import { ProjectTask } from '../models/ProjectTask';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { FilterProjectTaskRequestSerializer } from './FilterProjectTaskRequestSerializer';
import { ProjectTaskSerializer } from './ProjectTaskSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewProjectTaskResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewProjectTaskResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewProjectTaskResponse instance
   */
  static deserialize(json: string): DataviewProjectTaskResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewProjectTaskResponse instance
   */
  static fromObject(obj: any): DataviewProjectTaskResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewProjectTaskResponse');
    }


    const instance: DataviewProjectTaskResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        ProjectTaskSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterProjectTaskRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewProjectTaskResponse instances
   */
  static deserializeArray(json: string): DataviewProjectTaskResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewProjectTaskResponse instance to a JSON string
   */
  static serialize(instance: DataviewProjectTaskResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewProjectTaskResponse instance to a plain object
   */
  static toObject(instance: DataviewProjectTaskResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        ProjectTaskSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterProjectTaskRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewProjectTaskResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewProjectTaskResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
